import React from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import { Image } from 'expo-image';
import SolidButton from './SolidButton';
import usePlatform from '../../utils/hooks/usePlatform';
import { reloadAppAsync } from 'expo';
import { reloadAsync } from 'expo-updates';
import { StyleSheet, useUnistyles } from 'react-native-unistyles';

const ErrorScreen = ({ scheme: propScheme }) => {

    const { isWeb, isNative, isLandscape } = usePlatform();
    const { rt: { themeName } } = useUnistyles();
    const { width } = useWindowDimensions();

    const scheme = propScheme || themeName;
    const imgWidth = width * (isLandscape ? 0.5 : 1.5);
    const source = scheme === 'light' ? require('@/assets/bear/error_light.png') : require('@/assets/bear/error_dark.png');
    const bgColor = scheme === 'light' ? '#FEFEFE' : '#02060E';


    const handleReload = async () => {
        if (isNative && __DEV__) {
           reloadAppAsync();
        }
        else if(isNative && !__DEV__){
            // Use the reload function from expo-updates so that if a new version of the app is available, 
            // it will be loaded and potentially fix the issue
           reloadAsync(); 
        }
        else if(isWeb){
            window.location.reload();
        }
    };

    return (
        <View style={[styles.container(isWeb), { backgroundColor: bgColor }]}>
            <Image
                source={source}
                style={{ width: imgWidth, aspectRatio: 1536 / 1024 }}
                contentFit="contain"
            />
            <SolidButton text="Reload Reach" width={200} onPress={handleReload} type='primary' variant='muted' />
        </View>
    );
};


const styles = StyleSheet.create(({colors, fonts}) => ({
    container: (isWeb) => ({
        flex: 1,
        minHeight: isWeb ? '100vh' : undefined,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: isWeb ? 32 : 0,
        gap: 8,
    }),
    title: {
        color: colors.text,
        fontSize: 32,
        fontFamily: fonts.heading,
    },
    message: {
        marginBottom: 16,
        color: colors.textSecondary,
        fontSize: 16,
        fontFamily: fonts.body,
    }
}));

export default ErrorScreen;
